import { api } from './api'

export const updatePassword = async ({ currentPassword, newPassword }) => {
  const payload = {
    currentPassword: currentPassword || '',
    newPassword: newPassword || '',
  }

  const response = await api.put('/profile/security/identity/password', payload)
  if (!response) {
    throw new Error('No response received')
  }

  return response.data ?? true
}

export const getPasswordPolicy = async () => {
  const { data } = await api.get('/profile/security/identity/password-policy')
  if (!data) {
    throw new Error('No password policy received')
  }
  return data
}
